import { Design } from '../../../types';

/** Normalize all @see DesignGraphQlSchema objects on a @see Design. */
export function normalizeGraphqlSchemas(serialized: Design) {
  serialized.graphQLSchemas ??= [];
  serialized.graphQLSchemas.forEach((graphQlSchema) => {
    graphQlSchema.lastLocalChange ??= 0;
    graphQlSchema.lastSavedChange ??= 0;
  });
}
